import styled from 'styled-components';
import { colors, spacing, Body2 } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';
import { DateFormat, TimeFormat } from 'utils/l10n/datetime/types';
import { localizeDateTime } from 'utils/l10n';
import { recencyReadable } from '../utils';
import { TableCell } from './styled';

const Body2Underline = styled(Body2)`
  text-decoration: underline dashed ${colors.textSecondary};
  text-underline-offset: ${spacing.eighth};
`;

export const TimestampCell = ({ timestamp }: { timestamp: number | undefined }) => (
  <TableCell>
    {timestamp ? (
      <Tooltip
        tooltipContent={localizeDateTime(new Date(timestamp), {
          showTime: true,
          showOffset: false,
          dateStyle: DateFormat.Full,
          timeStyle: TimeFormat.TwelveHour,
        })}
      >
        <Body2Underline>{recencyReadable(timestamp)}</Body2Underline>
      </Tooltip>
    ) : (
      <Body2>Never</Body2>
    )}
  </TableCell>
);
